export const FETCH_WIRINGLIST_BEGIN = 'FETCH_WIRINGLIST_BEGIN';
export const FETCH_WIRINGLIST_SUCCESS = 'FETCH_WIRINGLIST_SUCCESS';
export const FETCH_WIRINGLIST_ERROR = 'FETCH_WIRINGLIST_ERROR';